// extracted by mini-css-extract-plugin
export default {"label":"_4yJIB","title":"Sokgi","disabled":"K3POh"};